import { useChatStore } from "@/store/chat.store";
import type { ThreadDto } from "@/api/chat/dto/thread.dto";
import type { DraftMessage, DraftMessageFile } from "@/types/chat";

export function useMessageDraft() {
  const chatStore = useChatStore();

  const draft = (thread: ThreadDto): DraftMessage => {
    return chatStore.getDraftMessage(thread.id);
  };

  const saveDraft = (threadId: number, message: string, file: DraftMessageFile | null): void => {
    chatStore.saveDraftMessage({ id: threadId, message, file });
  };

  const removeDraft = (threadId: number): void => {
    chatStore.removeDraftMessage(threadId);
  };

  return { draft, saveDraft, removeDraft };
}
